import getters from './getters';
import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    levels: [],
    items: {
      items: [],
      pagination: {},
    },
    customers: {
      customers: [],
      pagination: {},
    },
  },
  actions,
  mutations,
  getters,
};
